<template>
  <div class="section-header mb-2">
    <div class="section-header__first-row d-flex bd-highlight align-items-center">
      <ButtonLeftArrow @click="back"></ButtonLeftArrow>
      <div class="d-flex justify-content-between align-items-center w-100">
        <slot></slot>
      </div>
    </div>
    <div>
      <slot name="secondRow"></slot>
    </div>
  </div>
</template>

<script>
import ButtonLeftArrow from '@/components/button/ButtonLeftArrow.vue';

export default {
  components: {
    ButtonLeftArrow,
  },
  props: {
    backUrl: String,
  },
  methods: {
    back() {
      if (this.backUrl) {
        this.$router.push(this.backUrl);
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/variables";
h1 {
  color: #174169;
  font-size: 22px;
  letter-spacing: 0;
  line-height: 30px;
  margin: 0 12px 0 0;
  font-size: 21px;
  font-weight: 400;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  @include respond(tab-landscape) {
    max-width: 35rem;
    display: inline-block;
  }

  @include respond(phone) {
    max-width: 17rem;
  }

  @media (max-width: 420px) {
    max-width: 14rem;
    font-size: 1rem;
  }
}

.section-header {
  position: sticky;
  top: $toolbar-height;
  background: #fafdff;
  z-index: 30;
  min-height: 65px !important;

  @include respond(tab-landscape) {
    top: 0px;
    padding: 0;
  }

  &__first-row {
    padding: 16px 20px;
  }
}
</style>
